<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
  <p-tabPanel header="Sub Modules">
    <!-- <app-purchase-type [channelTypeId]="channelTypeId" [typesList]="allPurchaseTypes"
      [templateList]="allPurchaseTemplates" [typeConfig]="purchaseTypeConfig"
      [templateConfig]="purchaseTypeTemplateConfig" [tabIndex]="index" (moveStage)="getData($event)">
    </app-purchase-type> -->
    <app-purchase-type
      [purchaseSubmoduleTypeId]="purchaseSubmoduleTypeId"
      [purchaseSubmoduleConfig]="purchaseSubmoduleConfig"
      [allPurchaseSubmodule]="allPurchaseSubmodule">
    </app-purchase-type>
  </p-tabPanel>
  <!-- <p-tabPanel header="Status">
    <app-purchase-status 
      [purchaseStatusTypeId]="purchaseStatusTypeId"
      [purchaseStatusConfig]="purchaseStatusConfig"
      [allPurchaseStatus]="allPurchaseStatus"
    ></app-purchase-status>      
  </p-tabPanel> -->
  <p-tabPanel header="Template">
    <app-purchase-template [purchaseTemplateConfig]="purchaseTemplateConfig">
    </app-purchase-template>
  </p-tabPanel>
  <p-tabPanel header="Fields">
    <!-- <app-fields></app-fields> -->
    <app-purchase-fields></app-purchase-fields>
  </p-tabPanel>
  <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
    <ng-template pTemplate="header">
      <p-menu #configmenuPurchase id="config_menu_purchase" [model]="configMenuPurchaseItems" [popup]="true"
        appendTo="body">
      </p-menu>
      <span class="btnBars p-mr-0" (click)="configmenuPurchase.toggle($event)">
        <i class="pi pi-bars"></i>
      </span>
    </ng-template>
  </p-tabPanel>
</p-tabView>
